import { render, staticRenderFns } from "./EditCorrectionForm.vue?vue&type=template&id=26a1ea5c&"
import script from "./EditCorrectionForm.vue?vue&type=script&lang=js&"
export * from "./EditCorrectionForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCorrectionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports